export function initOrderDetails(login: any): {
    order: Order
    task: BaseTask
} {
    return {
        order: {
            generalDetails: {
                number: undefined,
                includesTowingTask: false,
                status: "open",
                caller: {
                    name: "",
                    companyName: "",
                    telephone: "",
                },
            },
        },
        task: {
            orderId: null,
            completedSteps: [],
            taskType: "oilSpillRemoval",
            status: "inProgress",
            meta: {
                createdBy: {
                    id: login?.tokenData?.id,
                    name: `${login?.user?.firstName} ${login?.user?.lastName}`,
                },
                editedBy: [],
                contactPerson: {
                    id: "",
                    name: "",
                },
                executingCompany: "Wohner GmbH",
            },
            generalDetails: {
                shortDescription: "",
                description: "",
                location: {},
                contactPerson: {
                    name: "",
                    phone: "",
                },
            },
        },
    }
}
